






























import { Component, Vue, Prop } from 'vue-property-decorator'

import { User } from '../../../store/user/types'
import { UserSearchFormParams } from '../../../type'
import UserSearchForm from '../../common/UserSearchForm.vue'
import { sortFilterUsers } from '../../../lib/appHelper'

@Component({ components: { UserSearchForm } })
export default class UserFilterDialog extends Vue {
  @Prop() value!: boolean
  @Prop() users!: User[]
  @Prop() initialParams!: UserSearchFormParams
  params = this.initialParams

  get filtered() {
    return sortFilterUsers(this.users, this.params)
  }

  handleChange(params: UserSearchFormParams) {
    this.params = params
  }

  handleSubmit() {
    this.$emit('submit', this.filtered)
  }
}
